import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { CSVReader } from 'react-papaparse';
import { ServiceAddressesVService, MetersVService } from '../../services/V2/gozer';
import { handleError } from '../shared/Functions';

export function BulkUpload({setShow, setLoading, loading, district}) {

    const handleCancel = () => {
        setShow(false)
    }

    const serviceAddressUpload = (data) => {
        let newServiceAddresses: any[] = [];
        for(let i = 1; i < data.length; i++){
            if(data[i].data.length !== data[0].data.length) continue;
            let serviceAddress = {
                districtId: district.id
            };
            data[i].data.forEach((x, index) => {
                serviceAddress[data[0].data[index]] =  x === "" ? null : x;
            })
            newServiceAddresses.push(serviceAddress)
        }
        ServiceAddressesVService.serviceAddressesVCreateAll(newServiceAddresses)
            .then(a => setLoading(!loading))
            .catch(err => handleError(err));
    }

    const meterUpload = (data) => {
        let meters: any[] = [];
        for(let i = 1; i < data.length; i++){
            if(data[i].data.length !== data[0].data.length) continue;
            let meter = {};
            data[i].data.forEach((x, index) => {
                meter[data[0].data[index]] =  x === "" ? null : x;
            })
            meters.push(meter)
        }
        MetersVService.metersVCreateAllMeters("null", meters)
            .then(a => setLoading(!loading))
            .catch(err => handleError(err));
    }

    return (
        <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Upload</DialogTitle>
            <DialogContent>
                <CSVReader
                    onDrop={serviceAddressUpload}
                    onError={(a,b,c,d) => console.log(a,b,c,d)}
                    addRemoveButton
                    >
                    <span>Drop CSV file here or click to upload multiple Service Addresses.</span>
                </CSVReader>
                <br />
                <CSVReader
                    onDrop={meterUpload}
                    onError={(a,b,c,d) => console.log(a,b,c,d)}
                    addRemoveButton
                    >
                    <span>Drop CSV file here or click to upload multiple Meters.</span>
                </CSVReader>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}